import React from 'react';
import { motion } from 'framer-motion';

const PostFeaturedImage = ({ image, title }) => {
  if (!image) return null;

  return (
    <motion.div 
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 0.2 }}
      className="mb-8 md:mb-12"
    >
      <img 
        src={image} 
        alt={`Featured image for blog post: ${title}`}
        className="w-full h-auto max-h-[500px] object-cover rounded-xl shadow-2xl"
        width="1200"
        height="600"
      />
    </motion.div>
  );
};

export default PostFeaturedImage;